// Function copied from gravity-blocks Gravity global functions - Needed for Filters index.js
export default function isEmpty(variable) {
    const type = typeof variable;

    if (variable == null) {
        return true;
    }

    if (Array.isArray(variable) || type === 'string') {
        return !variable.length;
    }

    if (type === 'object') {
        return !Object.keys(variable).length;
    }

    return false;
}
